import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesDifferentControlsForm } from './FormSamplesDifferentControlsForm';
import { FormSamplesDifferentControlsPageInfo } from './FormSamplesDifferentControlsPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface ExampleDto {
  textBox: string;
  date: string;
  time: string;
  dateTime: string;
  singleSelect: string;
  multipleSelect: string[];
  singleList: string;
  multipleList: string[];
  radioGroup: string;
  slider: number;
  switch: boolean;
  check: boolean;
  maskTelephone: string;
  maskOther: string;
}

export const FormSamplesDifferentControlsPage = () => {

  const [submittedValues, setSubmittedValues] = useState<ExampleDto | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false);
  const { showError } = useFeedback();

  const handleSubmit = async (values: ExampleDto) => {
    setSubmitting(true);
    setSubmittedValues(values);

    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PageContainer
      heading='Form Samples - Different Controls'
      icon={<TextSnippetIcon />}
      pageInfo={<FormSamplesDifferentControlsPageInfo />}
    >
      <PageDefaultSegment width={400}>
        <FormSamplesDifferentControlsForm
          submitting={submitting}
          onSubmit={handleSubmit}
        />
      </PageDefaultSegment>
      <FormSamplesOutput width={400} submittedValues={submittedValues} />
    </PageContainer>
  )
}
